import React, { useState } from 'react';
import {
  Box,
  Link,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const FAQ = () => {
  const [showAll, setShowAll] = useState(false);
  const [expanded, setExpanded] = useState(null);

  const qaList = [
    {
      question: 'How much will I earn?',
      answer: 'You receive a 5-8% commission for every booked experience using your QR code.',
    },
    {
      question: 'Who can become a CanAm Affiliate?',
      answer:
        "Anyone can qualify! We're always looking for enthusiastic affiliates who are passionate about travel.",
    },
    {
      question: 'What travel tours and activities do you offer?',
      answer:
        'As a growing company, we are constantly expanding our activities. CanAm currently offers over 15 unique tours and excursions in Punta Cana. We negotiate exciting deals with various vendors daily, from thrilling snorkelling adventures with marine creatures to unforgettable catamaran party boat experiences and ATV ride tours. You can earn a commission on any activity on CanAmExcursions.com.',
    },
    {
      question: 'How easy is it to navigate the website?',
      answer: (
        <>
          CanAm&apos;s site is user-friendly, minimalistic, and straightforward. If you have any
          questions, feel free to contact us at{' '}
          <Link color="primary" href="mailto:info@canamexcursions.com">
            info@canamexcursions.com
          </Link>
        </>
      ),
    },
    {
      question: 'Where and When Will I Get Paid?',
      answer: 'CanAm pays affiliates through PayPal every 30 days.',
    },
    {
      question: 'Are there any fees or costs associated with becoming a CanAm Affiliate?',
      answer: 'There are no fees - promoting as an affiliate is completely free.',
    },
    {
      question: 'Can I promote CanAm tours and activities on social media platforms?',
      answer:
        'Yes, we recommend promoting tours via social media or printing posters if you own a brick-and-mortar business.',
    },
    {
      question:
        'Is there a minimum number of bookings or sales I need to make to receive commissions?',
      answer: 'Nope - you can claim your commission earnings with no minimum earnings.',
    },
    {
      question: 'What happens if a customer cancels their booking? Will my commission be affected?',
      answer:
        'Customers using your QR code must keep bookings for affiliates to earn a commission.',
    },
  ];

  const visibleList = showAll ? qaList : qaList.slice(0, 4);

  return (
    <Box my={3} pl={{xs: 3, sm: 8}} pr={{xs: 3, sm: 0}}>
      <Box width="max-content" mx="auto">
        <Typography
          variant="h5"
          component="h5"
          color="#002C44"
          textAlign="center"
          sx={{
            width: 'fit-content',
            fontWeight: 700,
            fontFamily: 'Lato',
            fontSize: '1.8rem',
            paddingBottom: 1,
            my: 3,
          }}
        >
          FAQs
        </Typography>
      </Box>

      {visibleList.map((qa, index) => (
        <Accordion
          key={qa.question}
          expanded={expanded === index}
          onChange={() => setExpanded(expanded === index ? null : index)}
          sx={{
            border: expanded === index ?  'none' : '1px solid #0000001A',
            borderRadius: 5,
            backgroundColor: expanded === index ? '#E6F7FF' : '#fff',
            mb: 1,
            boxShadow: 'none',
            '&:before': { display: 'none' },
            '& .MuiAccordionSummary-root': {
              px: 2,
              py: 1.5,
            },
            '& .MuiAccordionSummary-expandIconWrapper': {
              color: '#FF6B00',
            },
            '& .MuiAccordionDetails-root': {
              px: 2,
              pb: 2,
              pt: 0,
            },
            '& .MuiTypography-root': {
              fontSize: '16px',
            },
            '& .Mui-expanded': {
              fontWeight: 'bold',
            },
          }}
          disableGutters
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`Q-${qa.question}`}
            id={`Q-${qa.question}`}
          >
            <Typography fontWeight="700 !important" >{qa.question}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography color="#000000BF">{qa.answer}</Typography>
          </AccordionDetails>
        </Accordion>
      ))}

      <Box textAlign="center" mt={2}>
        <Button
          onClick={() => setShowAll((prev) => !prev)}
          sx={{
            borderRadius: 20,
            textTransform: 'none',
            fontWeight: 500,
            px: 0,
            py: 1,
            minWidth: 'unset',
            '&:hover': {
              backgroundColor: 'transparent',
            },
          }}
        >
          {showAll ? <KeyboardArrowUpIcon sx={{color:'#15B5E8 !important'}} /> : <KeyboardArrowDownIcon sx={{color:'#15B5E8 !important'}} />}
        </Button>
      </Box>
    </Box>
  );
};

export default FAQ;
